import React, { Component } from 'react';
import { Container, Col, Row,CardBody, CardHeader, Card, FormGroup, Label, Input, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { forgotPasword } from '../../store/actions/userActions';
import { Link } from 'react-router-dom';


class Email extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email:'',
            selected:''
        };
    }

    onChange = (target) => {
        const { name, value } = target;
        this.setState({
            [name]: value
        })
    }
    sendmail = (email,type) => {
        this.props.forgotPasword(email,`admin`).then( (res) => {
            this.setState({email:'',selected:''});
        }).catch( (err) => {
            console.log("error")
        });
    }

    hexToRgbA =(hex)=>{
        var c;
        if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
            c= hex.substring(1).split('');
            if(c.length=== 3){
                c= [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c= '0x'+c.join('');
            return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',.7)';
        }
        throw new Error('Bad Hex');
    }

    render = () => {
        return <div className="app flex-row align-items-center custom_bg" >
			<Container>
				<Row className="justify-content-center">
					<Col xs="12" sm="12" md="5" lg="5">
                        <Card>
                            <CardHeader>
                                <h4>{this.props.json_lang.login.forgot_password_link}</h4>
                            </CardHeader>
                            <CardBody>
                                {/*<Label className={`text-muted`} htmlFor="type">{this.props.json_lang.common.type}</Label>
                                <select
                                    id={`type`}
                                    className="form-control"
                                    value={this.state.selected}
                                    onChange={(e) => this.setState({selected:e.target.value})}>
                                    <option value="">Seleccione...</option>
                                    <option value="admin">{this.props.json_lang.common.admin}</option>
                                    <option value="provider">{this.props.json_lang.common.provider}</option>
                                    <option value="client">{this.props.json_lang.common.client}</option>
                                </select>*/}
                                <FormGroup>
                                    <Label className={`text-muted mt-3`} htmlFor="email">{this.props.json_lang.common.email}</Label>
                                    <Input ref={ 'email' } type="text" name="email" placeholder={this.props.json_lang.common.email} value={this.state.email} onChange={ (e) => this.onChange(e.target) }/>
                                </FormGroup>

                                <Link to="/login">
                                    <Button color="link" className="px-0"> 
                                        {this.props.json_lang.common.home}
                                    </Button>
                                </Link>

                                <Button className="pull-right" color="primary" onClick={()=>this.sendmail(this.state.email,this.state.selected)}>{this.props.json_lang.common.continue}</Button>
                            </CardBody>
                        </Card>
					</Col>
				</Row>
			</Container>
		</div>
    }
}

const mapStateToProps = (state) => {
    return {
        errors: state.errors,
        account:state.account,
        json_lang: state.json_lang
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        forgotPasword: (email,type) => dispatch(forgotPasword(email,type))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Email);



// WEBPACK FOOTER //
// ./src/views/Password/Email.jsx